import React from "react";
import styles from "../styles/project.module.css";
import ProjectCard from "./ProjectCard";

const Project = () => {
  return (
    <div className={styles.project}>
      <h1 className={styles.projectTitle}>
        <span style={{ color: "#3ABFF8" }}>🚀 </span>Projects
      </h1>
      <div className={styles.cards}>
        <ProjectCard
          title="Frontend Lab"
          desOne="• Our expertly crafted frontend assessments provide hands-on experience in frontend development, helping you excel in both frontend and machine coding rounds."
          desTwo="• Get access to Figma files and design images to build assessments like a professional developer—all for FREE."
          desThree="• Receive valuable feedback on every assessment you submit to help you improve."
          desFour={`• Track your progress with timelines for each assessment in the "My Assessment" tab.`}
          imgSrc="/assets/frontendlab.png"
          tech={[]}
          githubLink="https://www.frontendlab.io/"
          liveLink="https://www.frontendlab.io/"
        />
        <ProjectCard
          title="SnapShop"
          desOne="• Developed a full-stack e-commerce app using the MERN stack."
          desTwo="• Implemented JWT for secure user authentication and Redux for efficient state management."
          desThree="• Designed RESTful APIs to handle user data, product information, order processing and utilized MongoDB as the database."
          desFour="• Implemented admin functionality to manage products, users, and order deliveries. Integrated PayPal SDK for seamless payment."
          imgSrc="/assets/snapshop.png"
          tech={["React", "Redux", "Express", "MongoDB", "Node.js"]}
          githubLink="https://github.com/Amitrai011/SnapShop"
          liveLink="https://snap-shops.vercel.app/"
        />
        <ProjectCard
          title="Blogging App"
          desOne="• Developed a Realtime Blogging Website using React and Firebase."
          desTwo="• Users can create account and log In to the website and can logout."
          desThree="• Users have the ability to create, update, delete, search and publish their blog posts."
          desFour="• Implemented React-Router-DOM to enable seamless website navigation for users without page reload."
          imgSrc="/assets/blog-web-app.png"
          tech={["React", "JavaScript", "Google Firebase", "CRUD"]}
          githubLink="https://github.com/Amitrai011/React-Blogging-Web-App"
          liveLink="https://write-blog-191a3.web.app"
        />
        <ProjectCard
          title="Code Canvas"
          desOne="• Code Canvas allows users to write and execute HTML, CSS, and JavaScript code."
          desTwo="• It also saves user code so that it is not wiped out when the user refreshes or quits their browser."
          desThree="• Code Canvas is designed to be responsive and can be accessed on various devices, including desktops, smartphones, and tablets."
          desFour="• It is a convenient tool for web developers who want to experiment with and test their code in a safe and user-friendly environment."
          imgSrc="/assets/code-canvas.png"
          tech={["HTML", "CSS", "JavaScript", "Responsive"]}
          githubLink="https://github.com/Amitrai011/Code-Canvas"
          liveLink="https://amitrai011.github.io/Code-Canvas/"
        />
        <ProjectCard
          title="Netflix Clone"
          desOne="• Developed a Netflix Clone using React that allows users to browse various categories movies and play trailers."
          desTwo="• Integrated multiple APIs, such as the TMDb API, to fetch movie data and display it on the app."
          desThree="• Used React Axios to handle HTTP requests and manage API data within the app."
          desFour="• It is designed to be responsive and can be accessed on various devices, including desktops, smartphones, and tablets."
          imgSrc="/assets/netflix-clone.png"
          tech={["React", "JavaScript", "API", "Axios"]}
          githubLink="https://github.com/Amitrai011/Netflix-Clone"
          liveLink="https://netflix-clone-bd4eb.web.app"
        />
      </div>
    </div>
  );
};

export default Project;
